import {useEffect, useRef, useState} from "react";
import iconFileTextOutline from "@iconify/icons-eva/file-text-outline";
import iconFileAddOutline from "@iconify/icons-eva/file-add-outline";
import iconPaperPlaneOutline from "@iconify/icons-eva/paper-plane-outline";
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
  Divider,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import {OrderListToolbar} from "../../components/_dashboard/order";

import axios from "axios";
import moment from "moment";
import {
  DELIVERY_TYPE_MAP,
  PAY_METHODS,
  PAY_METHOD_MAP,
  STORE_ORDER_STATUS,
  STORE_ORDER_STATUS_MAP
} from "src/config/constants";
import {alert} from "src/services/alert";
import MoreMenu from "src/components/common/MoreMenu";
import XLSX from "xlsx";
import FormDialog from "src/components/common/FormDialog";
import ConvertUtil from "src/utils/ConvertUtil";
import Confirm from "src/components/common/ConfirmDialog";
import ListHead from "src/components/common/ListHead";
import OrderRecordsDialog from "src/components/dialogs/OrderRecordsDialog";
import {asyncRequest} from "src/services/network";
import OrderDetailDialog from "src/components/dialogs/OrderDetailDialog";
import UserInfo from "src/components/common/UserInfo";
import CellImage from "src/components/common/CellImage";
import {Icon} from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/zh-cn";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import StoreProductPicker from "src/components/common/StoreProductPicker";
import ListToolbar from "src/components/common/ListToolbar";
// ----------------------------------------------------------------------
const payMethods = Object.values(PAY_METHODS);
const statuses = Object.values(STORE_ORDER_STATUS);

const TABLE_HEAD = [
  {id: "name", label: "用户ID", alignRight: false},
  {id: "orderSN", label: "订单编号", alignRight: false},
  {id: "productName", label: "商品名称", alignRight: false},
  {id: "buyCount", label: "购买数量", alignRight: false},
  // { id: "totalPrice", label: "商品总价(元)", alignRight: false },
  // { id: "price", label: "支付金额(元)", alignRight: false },
  // { id: "payMethod", label: "支付方式", alignRight: false },
  {id: "status", label: "状态", alignRight: false},
  // { id: "deliveryType", label: "收货方式", alignRight: false },
  {id: "receiver", label: "收件信息", alignRight: false},
  // { id: "receiverName", label: "收件人", alignRight: false },
  // { id: "receiverMobile", label: "收货人号码", alignRight: false },
  // { id: "receiverAddress", label: "收货地址", alignRight: false },
  {id: "userRemark", label: "买家留言", alignRight: false},
  {id: "create_at", label: "下单时间", alignRight: false},
  // { id: "supplier", label: "供应商", alignRight: false },
  {id: ""},
];

const moreMenus = [
  {title: "详情", icon: iconFileTextOutline},
  {title: "记录", icon: iconFileTextOutline},
  {title: "备注", icon: iconFileAddOutline},
  {title: "发货", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED]},
  // { title: "退款", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.REFUNDING] },
  {title: "核销", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED]},
  {
    title: "删除",
    icon: iconPaperPlaneOutline,
    limit: [STORE_ORDER_STATUS.FINISHED, STORE_ORDER_STATUS.DELETED, STORE_ORDER_STATUS.CANCELED]
  },
];

export default function SupplierOrderList() {
  const [curOrder, setCurOrder] = useState({});
  const [action, setAction] = useState();
  const [remark, setRemark] = useState("");
  const [deliverySN, setDeliverySN] = useState(""); // 物流信息
  const [verifyCode, setVerifyCode] = useState(""); // 核销码
  const [orders, setOrders] = useState([]);
  const [records, setRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [countMap, setCountMap] = useState({});
  const [product, setProduct] = useState({});
  const uploadRef = useRef();

  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    status: [],
    payMethod: -1,
    search: "",
    productId: null,
    orderSN: "",
    receiverMobile: "",
    startTime: null,
    endTime: null,
  });

  useEffect(() => {
    getOrders();
  }, [filter]);

  async function getOrders() {
    const {data, count, counts} = await asyncRequest({
      path: "/store/order/list",
      data: filter,
    });

    setOrders(
      data.map((d) => ({
        ...d,
        createdAt: moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        // payTime: d.payTime ? moment(d.payTime).format("YYYY-MM-DD HH:mm:ss") : d.payTime,
        productData: JSON.parse(d.productData) || [],
        // productName: JSON.parse(d.productData)[0].name,
      }))
    );
    setTotalItems(count);

    if (counts) {
      const map = {};
      for (let i = 0; i < counts.length; i++) {
        map[counts[i].status] = counts[i].count;
      }
      setCountMap(map);
    }
  }

  function handleSearch(val) {
    setFilter({
      ...filter,
      search: val,
    });
  }

  const handleChangePage = (event, newPage) => {
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter({
      ...filter,
      size: parseInt(event.target.value, 10),
      page: 1,
    });
  };

  function handleDateChange(dateRange) {
    setFilter({
      ...filter,
      createdAt: dateRange,
    });
  }

  function handleStatusChange(status) {
    setFilter({
      ...filter,
      status,
    });
  }

  // 操作条
  async function handleDownload() {
    const {data} = await asyncRequest({
      path: "/store/order/export",
      data: filter,
    });

    let productMap = {};
    {
      const ids = [];
      data.forEach((d) => {
        const productData = JSON.parse(d.productData);

        productData.forEach((pd) => {
          ids.push(pd.id);
        });
      });
      const {data: products} = await asyncRequest({
        path: "/store/product/list",
        data: {
          id: Array.from(new Set(ids)),
          page: 0,
          size: 10000,
        },
      });

      products.forEach((p) => {
        productMap[p.id] = p;
      });
    }

    exportOrders(
      data.map((d) => {
        const productData = JSON.parse(d.productData);
        const cost = productData.reduce((prev, next) => {
          return prev + (productMap[next.id] ? productMap[next.id].cost : 0) * next.count;
        }, 0);
        return {
          ...d,
          productData,
          cost,
          createdAt: moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss"),
          payTime: d.payTime ? moment(d.payTime).format("YYYY-MM-DD HH:mm:ss") : d.payTime,
        };
      })
    );
  }

  function exportOrders(orders) {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    const cellTitles = ["订单号", "收货人姓名", "收货人电话", "收货地址", "商品编号", "商品名称", "数量", "下单时间", "支付状态", "支付时间", "用户备注", "管理员备注", "物流单号", "快递公司"];
    const cellKeys = ["orderSN", "receiverName", "receiverMobile", "receiverAddress", "productId", "productName", "buyCount", "createdAt", "status", "payTime", "userRemark", "adminRemark", "deliverySN", "deliveryCompany"];
    const header = alphabets.slice(0, cellTitles.length);

    const data = [{}];
    for (let i = 0; i < header.length; i++) {
      const alphabet = header[i];
      data[0][alphabet] = cellTitles[i];

      let j = 1;

      orders.forEach((order) => {
        let productIdx = 0;
        order.productData.forEach((product) => {
          if (!data[j]) {
            data[j] = {};
          }

          const obj = {
            ...order,
            productId: product.id,
            productName: product.name,
            status: ConvertUtil.getOrderStatusText(order.status),
            payMethod: PAY_METHOD_MAP[order.payMethod],
            count: product.count,
          };
          data[j][alphabet] = obj[cellKeys[i]];

          j++;
          productIdx++;
        });
      });
    }

    var ws = XLSX.utils.json_to_sheet(data, {header, skipHeader: true});

    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, "订单信息");

    XLSX.writeFile(workbook, `订单导出${Date.now()}.xlsx`);
  }

  function filterMoreMenus(status) {
    const menus = [];
    for (let i = 0; i < moreMenus.length; i++) {
      if (moreMenus[i].limit && !moreMenus[i].limit.includes(status)) {
        continue;
      }

      menus.push(moreMenus[i]);
    }

    return menus;
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      page: 0,
      [ki]: val,
    });
  }

  function handleReset() {
    setFilter({
      page: 0,
      size: 20,
      status: [],
      payMethod: -1,
      productId: null,
      orderSN: "",
      receiverMobile: "",
      startTime: null,
      endTime: null,
    });
  }

  async function getOrderRecords(orderSN) {
    const {data} = await asyncRequest({
      path: "/store/order/records",
      data: {orderSN},
    });

    setRecords(data);
    setAction("records");
  }

  // 更多操作
  function handleMoreClick(title, row, ...args) {
    if (title === "详情") {
      setCurOrder(row);
      setAction("detail");
    } else if (title === "记录") {
      // setAction("records");
      getOrderRecords(row.orderSN);
    } else if (title === "发货") {
      setCurOrder(row);
      setAction("delivery");
    } else if (title === "备注") {
      setCurOrder(row);
      setRemark(row.adminRemark);
      setAction("remark");
    } else if (title === "核销") {
      // hexiao(row.orderSN);
      setCurOrder(row);
      setAction("hexiao");
    } else if (title === "删除") {
      delRow(row.orderSN);
    } else if (title === "确认支付") {
      confirmPay(row.orderSN);
    }
  }

  function handleDialogConfirm() {
    if (action === "remark") {
      setAdminRemark();
    } else if (action === "delivery") {
      fahuo();
    }
  }

  async function handleConfirmHexiao() {
    const {data} = await asyncRequest({
      path: "/store/order/hexiao",
      data: {orderSN: curOrder.orderSN, verifyCode},
    });

    getOrders();
    setAction();
  }

  async function setAdminRemark() {
    const {data} = await asyncRequest({
      path: "/store/order/remark",
      data: {orderSN: curOrder.orderSN, remark},
    });

    orders.find((t) => t.orderSN === curOrder.orderSN).adminRemark = remark;
    setOrders([...orders]);

    setAction();
  }

  async function fahuo() {
    const {data} = await asyncRequest({
      path: "/store/order/fahuo",
      data: {orderSN: curOrder.orderSN, deliverySN: deliverySN},
    });

    setOrders(orders.filter((t) => t.orderSN !== curOrder.orderSN));
    setAction();
    setDeliverySN("");
  }

  async function confirmPay(orderSN) {
    const {msg} = await asyncRequest({
      path: "/store/order/confirmPay",
      data: {orderSN},
    });

    setOrders(orders.filter((t) => t.orderSN !== orderSN));
    alert(msg, "success");
  }

  function refund(orderSN) {
    Confirm({
      message: "确认退款吗？",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/store/order/refund",
          data: {orderSN},
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function delRow(orderSN) {
    Confirm({
      message: "确定删除该条数据吗?",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/store/order/del",
          data: {orderSN},
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function handleUpload(e, type) {
    console.log(e);
    if (!e.target.files[0]) return;
    let reader = new FileReader();
    reader.onload = (event) => {
      uploadRef.current.value = null;
      try {
        // 判断文件类型是否正确
        // if (".xls" != suffix && ".xlsx" != suffix) {
        //     message.error("选择Excel格式的文件导入!");
        //     return false;
        // }
        let {result} = event.target;
        // 读取文件
        let workbook = XLSX.read(result, {type: "binary"});
        let data = [];
        // 循环文件中的每个表
        let loaded = false;
        for (let sheet in workbook.Sheets) {
          // console.log('sheet: ', sheet);
          // if (workbook.Sheets.hasOwnProperty(sheet)) {
          //   // 将获取到表中的数据转化为json格式
          // }
          if (loaded) continue;

          const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {defval: ""});
          console.log(sheetData);
          // setInitialData(sheetData);
          // setShowImportDialog(true);
          if (type === 'settle') {
            handleBulkSettle([...sheetData])
          } else {
            handleBulkSend([...sheetData]);
          }
          loaded = true;
        }
        // console.log("data:", data);
      } catch (e) {
        console.log(e);
        alert("文件类型不正确！");
      }
    };
    reader.readAsBinaryString(e.target.files[0]);
    // console.log(e.target.files[0])
  }

  function handleBulkSend(items) {
    Confirm({
      message: "确定批量发货吗？",
      async onConfirm() {
        const orders = [];

        for (let index = 0; index < items.length; index++) {
          const order = items[index];

          if (!order["物流单号"]) continue;

          orders.push({
            orderSN: order["订单号"],
            deliverySN: order["物流单号"],
            deliveryCompany: order["物流公司"],
          });
        }

        console.log(orders, items);

        // return;

        const {msg} = await asyncRequest({
          path: "/store/order/bulkFahuo",
          data: {orders},
        });

        alert(msg, "success");
        getOrders();
      },
    });
  }

  function handleBulkSettle(items) {
    Confirm({
      message: "确定批量设置对账状态吗？",
      async onConfirm() {
        const orders = [];
        for (let index = 0; index < items.length; index++) {
          const order = items[index];
          orders.push({
            orderSN: order["订单号"],
            isSettle: order["是否对账"],
          });
        }
        console.log(orders, items);
        const {msg} = await asyncRequest({
          path: "/store/order/bulk/settle",
          data: {orders},
        });
        alert(msg, "success");
        getOrders();
      },
    });
  }

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - orders.length) : 0;
  const emptyRows = 0;

  return (
    <Page title="商城订单">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            商城订单
          </Typography>

          <Button
            variant="contained"
            startIcon={<Icon icon={plusFill}/>}
            onClick={() => {
              setAction("addOrder");
            }}
          >
            添加订单
          </Button>
        </Stack>

        <Card>
          <ListToolbar total={totalItems} countMap={countMap} onDateChange={handleDateChange}
                       onStatusChange={handleStatusChange} onSearch={handleSearch} onExport={handleDownload}
                       onRefresh={getOrders} onReset={handleReset}>
            <Grid container gap={2}>
              <Grid item>
                <TextField
                  style={{width: 200}}
                  label="手机号"
                  placeholder="手机号"
                  autoComplete="off"
                  id="receiverMobile"
                  size="small"
                  value={filter.receiverMobile}
                  onChange={(evt) => {
                    handleFilterChange("receiverMobile", evt.target.value);
                  }}
                />
              </Grid>

              <Grid item>
                <TextField
                  style={{width: 200}}
                  label="商品"
                  placeholder="商品"
                  autoComplete="off"
                  id="productId"
                  size="small"
                  value={product.name}
                  onClick={() => {
                    StoreProductPicker({
                      onSelect(val) {
                        setProduct(val);
                        handleFilterChange("productId", val.id);
                      },
                    });
                  }}
                />
              </Grid>

              <Grid item>
                <TextField
                  style={{width: 200}}
                  label="订单编号"
                  placeholder="订单编号"
                  autoComplete="off"
                  id="orderSN"
                  size="small"
                  value={filter.orderSN}
                  onChange={(e) => {
                    handleFilterChange("orderSN", e.target.value);
                  }}
                />
              </Grid>

              <Grid item>
                <TextField
                  style={{width: 200}}
                  label="物流编号"
                  placeholder="物流编号"
                  autoComplete="off"
                  id="deliverySN"
                  size="small"
                  value={filter.deliverySN}
                  onChange={(e) => {
                    handleFilterChange("deliverySN", e.target.value);
                  }}
                />
              </Grid>

              <Grid item>
                <FormControl size="small">
                  <InputLabel>状态</InputLabel>
                  <Select
                    label="状态"
                    multiple
                    value={filter.status}
                    onChange={(e) => {
                      handleFilterChange("status", e.target.value);
                    }}
                    style={{width: 250}}
                  >
                    {[-1, ...statuses].map((status, idx) => (
                      <MenuItem key={idx} value={status} name={status}>
                        {status == -1 ? "全部" : STORE_ORDER_STATUS_MAP[status]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item>
                <FormControl size="small">
                  <InputLabel>支付方式</InputLabel>
                  <Select
                    label="支付方式"
                    value={filter.payMethod}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        payMethod: e.target.value,
                      });
                    }}
                    style={{width: 250}}
                  >
                    {[-1, ...payMethods].map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {idx == 0 ? "全部" : PAY_METHOD_MAP[type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item>
                <FormControl size="small">
                  <InputLabel>发货方式</InputLabel>
                  <Select
                    label="发货方式"
                    value={filter.deliveryType}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        deliveryType: e.target.value,
                      });
                    }}
                    style={{width: 250}}
                  >
                    {[-1, "EXPRESS", "ZITI"].map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {idx == 0 ? "全部" : DELIVERY_TYPE_MAP[type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item>
                {/* <MyDateRangePicker
                  value={filter.createdAt}
                  onChange={(val) => {
                    handleFilterChange("createdAt", val);
                  }}
                /> */}

                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
                  <DateTimePicker
                    views={["year", "day", "hours", "minutes", "seconds"]}
                    ampm={false}
                    label="起始时间"
                    size="small"
                    value={moment(filter.startTime)}
                    onChange={(newValue) => {
                      console.log(newValue);
                      const d = moment(new Date(newValue)).format("YYYY-MM-DD hh:mm:ss");
                      handleFilterChange("startTime", new Date(newValue));
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
                  <DateTimePicker
                    views={["year", "day", "hours", "minutes", "seconds"]}
                    ampm={false}
                    label="终止时间"
                    size="small"
                    value={moment(filter.endTime)}
                    onChange={(newValue) => {
                      console.log(newValue);
                      const d = moment(new Date(newValue)).format("YYYY-MM-DD hh:mm:ss");
                      handleFilterChange("endTime", new Date(newValue));
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item>
                <Button component="label">
                  批量发货
                  <input ref={uploadRef} hidden
                         accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                         type="file" onChange={(e) => handleUpload(e, 'faHuo')}/>
                </Button>
                <Button component="label">
                  批量发货
                  <input ref={uploadRef} hidden
                         accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                         type="file" onChange={(e) => handleUpload(e, 'settle')}/>
                </Button>
              </Grid>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{minWidth: 800}}>
              <Table>
                <ListHead headLabel={TABLE_HEAD}/>
                <TableBody>
                  {orders.map((row) => {
                    const {
                      id,
                      uid,
                      payPrice,
                      payMethod,
                      deliveryType,
                      totalPrice,
                      buyCount,
                      productData,
                      createdAt,
                      status,
                      orderSN,
                      userRemark,
                      receiverAddress,
                      receiverName,
                      receiverMobile,
                      user
                    } = row;
                    // const isItemSelected = selected.indexOf(nickname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell> */}
                        {/* <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Avatar alt={nickname} src={`${BASE_URL}${avatar}`} />
                              <Typography variant="subtitle2" noWrap>
                                {nickname || uid}
                              </Typography>
                            </Stack>
                          </TableCell> */}
                        <TableCell align="left">
                          <UserInfo {...user} />
                        </TableCell>
                        <TableCell align="left">{orderSN}</TableCell>
                        <TableCell align="left" sx={{minWidth: 260}}>
                          {productData.map((p) => (
                            <Stack direction="row" spacing={1}>
                              <CellImage src={p.cover} style={{width: 60, height: 60, objectFit: "contain"}}/>
                              <Stack>
                                <Typography>{p.name}</Typography>
                                <Typography>x{p.count}</Typography>
                              </Stack>
                            </Stack>
                          ))}
                        </TableCell>
                        <TableCell align="left">{buyCount}</TableCell>
                        {/* <TableCell align="left">{totalPrice}</TableCell>
                        <TableCell align="left">{payPrice}</TableCell>
                        <TableCell align="left">{PAY_METHOD_MAP[payMethod]}</TableCell> */}
                        <TableCell align="left">
                          <Label variant="ghost" color={ConvertUtil.getOrderStatusColor(status)}>
                            {ConvertUtil.getOrderStatusText(status)}
                          </Label>
                        </TableCell>
                        {/* <TableCell align="left">{deliveryType == 'EXPRESS' ? '快递配送' : '自提'}</TableCell> */}
                        <TableCell align="left" sx={{minWidth: 150}}>
                          {deliveryType == "ZITI" ? (
                            "自提"
                          ) : (
                            <Stack>
                              <span>{receiverName}</span>
                              <span>{receiverMobile}</span>
                              <span>{receiverAddress}</span>
                            </Stack>
                          )}
                        </TableCell>
                        <TableCell align="left">{userRemark}</TableCell>
                        <TableCell align="left">{createdAt}</TableCell>

                        <TableCell align="right">
                          <MoreMenu spread={false} menus={filterMoreMenus(status)}
                                    onMoreClick={(title) => handleMoreClick(title, row)}/>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{height: 53 * emptyRows}}>
                      <TableCell colSpan={6}/>
                    </TableRow>
                  )}
                </TableBody>
                {orders.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{py: 3}}>
                        <SearchNotFound searchQuery={filter.search}/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" sx={{p: 2}}>
              {/* <Typography variant="caption" component="span">
                预期利润：{100}
              </Typography>
              <Divider orientation="vertical" flexItem sx={{mx: 1}} />
              <Typography variant="caption" component="span" >
                完单利润：{100}
              </Typography> */}
            </Stack>
            <TablePagination labelRowsPerPage="每页行数" rowsPerPageOptions={[10, 20]} component="div"
                             count={totalItems} rowsPerPage={filter.size} page={filter.page}
                             onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage}/>
          </Stack>
        </Card>
      </Container>

      {/* 详情 */}
      <OrderDetailDialog order={curOrder} open={action === "detail"} onClose={() => setAction()}/>

      {/* 记录 */}
      <OrderRecordsDialog rows={records} open={action === "records"} onClose={() => setAction()}/>

      <FormDialog title={`订单${curOrder.orderSN}备注`} open={action === "remark"} onConfirm={handleDialogConfirm}
                  onClose={() => setAction()}>
        <TextField autoComplete="false" autoFocus id="adminRemark" value={remark} label="管理员备注" fullWidth
                   variant="standard" onChange={(e) => setRemark(e.target.value)}/>
      </FormDialog>

      <FormDialog title={`订单${curOrder.orderSN}发货`} open={action === "delivery"} onConfirm={handleDialogConfirm}
                  onClose={() => setAction()}>
        <TextField autoComplete="false" autoFocus id="transport" value={deliverySN} label="物流单号"
                   placeholder="(选填)" fullWidth variant="standard" onChange={(e) => setDeliverySN(e.target.value)}/>
      </FormDialog>

      <FormDialog title={`订单${curOrder.orderSN}核销`} open={action === "hexiao"} onConfirm={handleConfirmHexiao}
                  onClose={() => setAction()}>
        <TextField autoComplete="false" autoFocus id="transport" value={verifyCode} label="核销码" placeholder="(选填)"
                   fullWidth variant="standard" onChange={(e) => setVerifyCode(e.target.value)}/>
      </FormDialog>
    </Page>
  );
}
